import React, { memo, useMemo } from "react";
import { FixedSizeList as List } from "react-window";
import { Box, Stack } from "@mui/material";
import CardAlerts from "./index";

// Defined outside component to avoid recreating on each render (react-window requirement)
const Row = ({ index, style, data }) => {
  const alerta = data.alertasTotais[index];
  return (
    <Box sx={style}>
      <CardAlerts
        alert={alerta}
        setFocusNodeId={data.search}
        isScrolling={data.isScrolling}
        selectionMode={data.selectionMode}
        isSelected={data.selectedAlerts.has(alerta.eventid)}
        onToggleSelect={data.onToggleSelect}
      />
    </Box>
  );
};

const VirtualizedAlerts = memo(
  ({
    alertasTotais,
    search,
    style,
    selectionMode = false,
    selectedAlerts = new Set(),
    onToggleSelect = () => {},
  }) => {
    const isScrolling = alertasTotais.length * 100 > window.innerHeight;

    const itemData = useMemo(
      () => ({
        alertasTotais,
        search,
        isScrolling,
        selectionMode,
        selectedAlerts,
        onToggleSelect,
      }),
      [alertasTotais, search, isScrolling, selectionMode, selectedAlerts, onToggleSelect],
    );

    // Key resets scroll when the visible alert list changes (e.g. on filter changes).
    // selectedAlerts changes flow through itemData without resetting scroll.
    const listKey = alertasTotais.length + "_" + (alertasTotais[0]?.eventid || "");

    return (
      <Stack direction="column" gap={1} sx={[style, { paddingRight: "0px" }]}>
        <List
          key={listKey}
          height={window.innerHeight}
          itemCount={alertasTotais.length}
          itemSize={100}
          width="100%"
          itemData={itemData}
        >
          {Row}
        </List>
      </Stack>
    );
  },
  (prevProps, nextProps) => {
    return (
      JSON.stringify(prevProps.alertasTotais) ===
        JSON.stringify(nextProps.alertasTotais) &&
      prevProps.selectionMode === nextProps.selectionMode &&
      prevProps.selectedAlerts === nextProps.selectedAlerts
    );
  },
);

export default VirtualizedAlerts;
